import ActionTypes from "../../constants/action_types";

export default function documentStateClear() {
  return {
    type: ActionTypes.DOCUMENT_STATE_CLEAR.SUCCESS,
  };
}
